import { toast, Toast } from 'react-hot-toast'
import './styles.css'
import CloseButton from '../../assets/images/close_rg.svg'

export const showToast = (message: string, supportId?: string) => {
  toast.custom(
    (t: Toast) => (
      <div className="toast">
        <div className="toast-content">
          <span className="toast-icon">⚠️</span>
          <div>
            <span>{message}</span>
            {supportId && <span className="toast-support-id">Support ID: {supportId}</span>}
          </div>
        </div>
        <button className="toast-close" onClick={() => toast.dismiss(t.id)}>
          <img className="close-img" src={CloseButton} alt="Close" />
        </button>
      </div>
    ),
    {
      position: 'bottom-right',
      duration: Infinity,
    },
  )
}
